import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTabsModule } from '@angular/material/tabs';
import { AnalyticsComponent } from './components/analytics/analytics.component';
import { ApplicationRoutingModule } from './analytics-routing.module';
import { DeploymentGraphsComponent } from '../deployment/components/deployment-graphs/deployment-graphs.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { NgbModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { MatAutocomplete } from '@angular/material/autocomplete';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from '@danielmoncada/angular-datetime-picker';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxPaginationModule } from 'ngx-pagination';
import { DeploymentRoutingModule } from '../deployment/deployment-routing.module';
import { AngularMaterialModule } from 'src/app/shared/material-module';
import { CoreModule } from 'src/app/core/core.module';
import { NgChartsModule } from 'ng2-charts';
import { ResizableModule } from 'src/app/core/directive/resizable/resizable.module';
import { GoogleChartsModule } from 'angular-google-charts';
import { NgxGaugeModule } from 'ngx-gauge';
import { SharedModule } from '../shared/shared.module';
import { AppRoutingModule } from 'src/app/app-routing.module';
import { BrowserModule } from '@angular/platform-browser';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';



@NgModule({
  declarations: [
    DeploymentGraphsComponent,
    AnalyticsComponent
],
  imports: [
    BrowserModule,
    AppRoutingModule,
    CommonModule,
    MatTabsModule,
    ApplicationRoutingModule,
    NgxSpinnerModule,
    NgbTooltipModule,
    NgSelectModule,
    MatAutocomplete,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    FormsModule,
    ReactiveFormsModule,
    NgxPaginationModule,
    DeploymentRoutingModule,
    AngularMaterialModule,
    CoreModule,
    NgChartsModule,
    NgbModule,
    ResizableModule,
    GoogleChartsModule,
    NgxGaugeModule,
    SharedModule,
    NgMultiSelectDropDownModule
],
  exports: [AnalyticsComponent]
})
export class AnalyticsModule { }
